import { useEffect, useRef } from 'react';
import './DateRangePicker.scss';

const fmt = str => {
  if (!str) return null;
  return new Date(str + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const DateRangePicker = ({ startDate, endDate, onChange }) => {
  const panelRef = useRef(null);
  const triggerRef = useRef(null);

  // Close panel on outside click
  useEffect(() => {
    const handler = e => {
      if (
        panelRef.current && !panelRef.current.contains(e.target) &&
        triggerRef.current && !triggerRef.current.contains(e.target)
      ) {
        panelRef.current.removeAttribute('data-open');
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggle = () => {
    if (panelRef.current.hasAttribute('data-open')) {
      panelRef.current.removeAttribute('data-open');
    } else {
      panelRef.current.setAttribute('data-open', '');
    }
  };

  return (
    <div className="drp">
      <div className="drp-display" ref={triggerRef} onClick={toggle}>
        <span className="drp-icon">📅</span>
        {startDate ? (
          <>
            <span className="drp-val">{fmt(startDate)}</span>
            <span className="drp-sep">→</span>
            <span className="drp-val">{fmt(endDate) ?? <span className="drp-placeholder">End date</span>}</span>
          </>
        ) : (
          <span className="drp-placeholder">Select dates</span>
        )}
        <span className="drp-chevron">▾</span>
      </div>

      <div className="drp-panel" ref={panelRef}>
        <label className="drp-label">
          <span>From</span>
          <input
            type="date"
            value={startDate}
            onChange={e => {
              onChange('startDate', e.target.value);
              if (endDate && e.target.value > endDate) onChange('endDate', '');
            }}
          />
        </label>
        <span className="drp-panel-arrow">→</span>
        <label className="drp-label">
          <span>To</span>
          <input
            type="date"
            value={endDate}
            min={startDate || undefined}
            onChange={e => onChange('endDate', e.target.value)}
          />
        </label>
      </div>
    </div>
  );
};

export default DateRangePicker;
